// extracted by mini-css-extract-plugin
export var tabBar = "styles-module__tabBar___gL550";
export var waypointsWrapper = "styles-module__waypointsWrapper___vJ_wP";